module.exports = __webpack_public_path__ + "img/produit-retour.f05fd45c.svg";